import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { onFieldChange } from '../../actions/Drawer';
import Loading from '../loading';
import './index.css';
import {
	UserOutlined,
	MenuOutlined,
	AuditOutlined,
	KeyOutlined,
	GlobalOutlined,
	ToolOutlined,
	DownloadOutlined
} from '@ant-design/icons';
import { Select, Divider, Menu, Layout, Image } from 'antd';
import GeneralHelper from '../../helpers/general';
const { Sider } = Layout;
const { Option } = Select;

export class Drawer extends Component {
	constructor(props) {
		super(props);
		this.ref = React.createRef();
		this.selectRef = React.createRef();
	}
	state = {
		collapsed: false,
		broken: false,
		openKeys: ['equipments-overview']
	};

	getActiveSubmenu() {
		const pathname = this.props.location.pathname;
		switch (true) {

			case /\/equipments-overview/.test(pathname):
				this.setState({
					openKeys: ['equipments-overview']
				});
				break;
			case /\/locations/.test(pathname):
				this.setState({
					openKeys: ['locations']
				});
				break;
			case /\/equipments/.test(pathname):
				this.setState({
					openKeys: ['equipments']
				});
				break;
			case /\/equipment-controller-status/.test(pathname):
				this.setState({
					openKeys: ['equipment-controller-status']
				});
				break;
			case /\/api-keys/.test(pathname):
				this.setState({
					openKeys: ['api-keys']
				});
				break;
			case /\/admins/.test(pathname):
				this.setState({
					openKeys: ['admins']
				});
				break;
			case /\/reports/.test(pathname):
				this.setState({
					openKeys: ['reports']
				});
				break;
			default:
				break;
		}
	}

	getImageBasePath() {
		return process.env.NODE_ENV === 'local' ? '' : '/eqc/admin';
	}

	onFieldChange = (value, text) => {
		if (value) {
			localStorage.setItem(
				'crf',
				JSON.stringify({
					crf_id: value,
					crf_name: text
				})
			);
		}
		this.props.onFieldChange('crf_id', value);
	};

	onOpenChange = key => {
		if(key.key !== 'burger') {
			this.setState({
				openKeys: [key.key]
			});
		}
	};

	handleClickOutside(event) {
		const { broken } = this.state;
		if (this.ref.current && this.selectRef.current === null && !this.ref.current.contains(event.target) && broken) {
			this.setState({ collapsed: true });
		}
	}

	componentDidMount() {
		document.addEventListener('click', this.handleClickOutside.bind(this), true);
		this.getActiveSubmenu();
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside.bind(this), true);
	}

	render() {
		const { collapsed, broken, openKeys } = this.state;
		const { crf_options, drawer } = this.props;
		const handleMenuClick = () => {
			if (broken) {
				this.setState({
					collapsed: true
				});
			}
		};

		const menuItems = [
			collapsed && {
				key: 'burger',
				style: { textOverflow: 'clip', background: 'none' },
				icon: <MenuOutlined />,
				onClick: () => {
					this.setState({
						collapsed: false
					});
				}
			},
			{
				key: 'equipments-overview',
				icon: <AuditOutlined />,
				label: (
					<Link to="/equipments-overview">Equipment Status Overview</Link>
				),
				onClick: () => handleMenuClick
			},
			{
				key: 'locations',
				icon: <GlobalOutlined />,
				label: (
					<Link to="/locations">Location Management</Link>
				),
				onClick: () => handleMenuClick
			},
			{
				key: 'equipments',
				icon: <ToolOutlined />,
				label: (
					<Link to="/equipments">Equipment Management</Link>
				),
				onClick: () => handleMenuClick
			},
			{
				key: 'equipment-controller-status',
				icon: <AuditOutlined />,
				label: (
					<Link to="/equipment-controller-status">Equipment Controller Status</Link>
				),
				onClick: () => handleMenuClick
			},
			{
				key: 'api-keys',
				icon: <KeyOutlined />,
				label: (
					<Link to="/api-keys">API Key Management</Link>
				),
				onClick: () => handleMenuClick
			},
			{
				key: 'admins',
				icon: <UserOutlined />,
				label: (
					<Link to="/admins">Admin Management</Link>
				),
				onClick: () => handleMenuClick
			},
			{
				key: 'reports',
				icon: <DownloadOutlined />,
				label: (
					<Link to="/reports">Report Download Page</Link>
				),
				onClick: () => handleMenuClick
			}
		];

		return (
			<Sider
				collapsible
				breakpoint="lg"
				collapsedWidth="45px"
				collapsed={collapsed}
				onCollapse={() => {
					this.setState({
						collapsed: !collapsed
					});
				}}
				ref={this.ref}
				onBreakpoint={broken => {
					this.setState({
						broken
					});
				}}
				trigger={<MenuOutlined />}
				style={{
					overflow: 'auto',
					minHeight: '100%',
					background: '#101424',
					position: 'relative'
					// background: '#fff', borderRight: '1px solid rgba(34,36,38,.15)'
				}}
				width={270}
			>
				{!collapsed &&
				<>
					<center style={{marginTop: 25}}>
						<Image
							preview={false}
							src={`${GeneralHelper.getImageBasePath()}/images/logo-white.svg`}
						/>
					</center>
					<Divider style={{ background: 'rgba(255, 255, 255, 0.65)' }} />
					<center style={{ padding: '3px 40px', fontSize: 15 }}>
						{!drawer.crf_id ? (
							<Loading
								custom={{margin: '0 auto'}}
								color="#ffffff"
							/>
						) : (
							<Select
								showSearch
								name="crf_id"
								placeholder="Select CRF"
								optionFilterProp="children"
								onChange={(val, e) => {
									this.onFieldChange(val, e.children);
									handleMenuClick();
									this.selectRef.current = null;
								}}
								onFocus={(e) => {
									this.selectRef.current = 'changed';
								}}
								style={{ width: '100%' }}
								defaultValue={drawer.crf_id}
								filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
							>
								{crf_options && crf_options.map(crf =>
									<Option
										key={crf.value}
										value={crf.value}
									>{crf.text}</Option>
								)}
							</Select>
						)}
					</center>
					<Divider style={{ background: 'rgba(255, 255, 255, 0.65)', margin: '25px 0px 5px'}} />
					</>
				}
				<Menu
					className="bt-drawer"
					style={{ margin: 0, height: '100vh', backgroundColor: '#101424' }}
					onClick={this.onOpenChange}
					mode="inline"
					selectedKeys={openKeys}
					theme="dark"
					items={menuItems}
				/>
			</Sider>
		);
	}
}

const mapsStateToProps = state => ({
	drawer: state.drawerReducer
});

const mapsDispatchToProps = dispatch => ({
	onFieldChange(fieldName, fieldValue) {
		dispatch(onFieldChange(fieldName, fieldValue));
	}
});

export default connect(mapsStateToProps, mapsDispatchToProps)(Drawer);
